export const domAttrSet = (dom, attrs) => {
    for (let a in attrs) {
        let v = attrs[a]
        if (v===undefined) {
            dom.removeAttribute(a)
        } else {
            dom.setAttribute(a, v)
        }
    }
}

export const preventDefaultEventsFn = (inputRef, events=[]) => (() => {
    const fn = (e) => { e.preventDefault() }
    const el = inputRef.current
    if (!el) return

    if(events.includes('wheel-on-number-input')) {
        el.addEventListener('wheel', fn, { passive:false })
    }

    return () => {
        if (!el) return
        if(events.includes('wheel-on-number-input')) {
            el.removeEventListener('wheel', fn)
        }
    }
})
